import {useTranslation} from 'react-i18next';
import LastLogin from './LastLogin';
import SnsAuth from './SnsAuth';
import Alert from '../../common/component/Alert';
import {ButtonSet} from '../../common/type/alert';
import {LOGIN_TITLE_KEY_MAP} from '../common';
import {
  IAuthModal,
  IAuthModalType,
  ILastLoginAuth,
  IGlobalLoginMethod,
} from '../type';

interface IProps {
  modalType?: IAuthModalType;
  authModal: IAuthModal;
  isExistAlert: boolean;
  lastLoginAuth?: ILastLoginAuth;
  onClickLoginSns: (loginMethod: IGlobalLoginMethod) => void;
  goLoginModal: () => void;
  onClickClose: () => void;
}

export default function AuthModal({
  modalType,
  authModal,
  isExistAlert,
  lastLoginAuth,
  onClickLoginSns,
  goLoginModal,
  onClickClose,
}: IProps) {
  const {t} = useTranslation();
  const {show, titleType} = authModal;
  const loginTitleKey = titleType && LOGIN_TITLE_KEY_MAP[titleType];
  const title = t(loginTitleKey || 'login_global_popup');
  const desc = (
    <>
      {modalType === 'login' && <SnsAuth onClickLoginSns={onClickLoginSns} />}
      {modalType === 'lastLogin' && lastLoginAuth && (
        <LastLogin
          lastLoginAuth={lastLoginAuth}
          onClickLoginSns={onClickLoginSns}
          goLoginModal={goLoginModal}
        />
      )}
    </>
  );
  return (
    <Alert
      isOpen={show && !!modalType && !isExistAlert}
      title={title}
      desc={desc}
      onRequestClose={onClickClose}
      buttonSet={ButtonSet.Cancel}
      labelClose={t('common_close')}
      spaceClassName="px-20"
    />
  );
}
